const riskFactorKeys = {
  all: ['riskFactors'],
  lists: (diseaseId: string) => [...riskFactorKeys.all, diseaseId, 'list'],
  records: () => [...riskFactorKeys.all, 'record'],
  record: (riskFactorId: string) => [...riskFactorKeys.records(), riskFactorId]
};

export { riskFactorKeys };
